module.exports = __webpack_public_path__ + "static/media/makesThick.aecd042d.mp3";